import VideoPlayer from "./VideoPlayer";

export default class AsyncLoader
{
    constructor()
    {
        const view = document.querySelector('.view')
        const charFiles = view.dataset.files
        const key = view.dataset.key
        const regex = new RegExp(key, 'g')
        const files = charFiles.replace(regex, '"')

        this.load(JSON.parse(files))
    }
    load(files)
    {
        for(const file of files)
        {
            const extension = file.substr(file.lastIndexOf('.') + 1)
            const path = file.replace('/wordpress', '')

            if(extension == 'png' || extension == 'jpg' || extension == 'jpeg' || extension == 'svg'|| extension == 'jpg' || extension == 'gif')
            {
                new Image().src = path
            }
            else if(extension == 'mp4')
            {
                document.createElement('video').src = path
            }
            else if(extension == 'mp3' || extension == 'wav')
            {
                new Audio(path)
            }
        }
    }
}